import { useQuery } from '@tanstack/react-query';
import api from '~/api';
import { useShippingClaim } from '~/features/shippingClaimReview/ShippingClaimReviewProvider';
import { useIsConciergeWidget } from '~/hooks/widgetHooks';
import { useStoreId } from '~/providers/StoreUserProvider';

export function useShippingClaimMessagesQuery() {
  const shippingClaim = useShippingClaim();
  const isCorsoConcierge = useIsConciergeWidget();

  const storeId = useStoreId();

  return useQuery({
    enabled: !!shippingClaim.id && !isCorsoConcierge,
    throwOnError: false,
    queryKey: ['shippingClaimMessages', shippingClaim.id, storeId],
    queryFn: () =>
      api
        .store(storeId)
        .shippingProtection.claim(`${shippingClaim.id}`)
        .messages(),
  });
}
